<template>
    <div>
        <div v-if="customFirstRow" class="details">
            <div class="details__label col-1">
                <slot name="firstRowLabel" />
            </div>
            <div class="details__content col-11">
                <slot name="firstRowContent" />
            </div>
        </div>

        <div v-if="showDetails" class="wrapper">
            <div v-for="detailsRow in detailsConfig" :key="detailsRow.field" class="details">
                <div class="details__label col-1 spacer">
                    {{ suffixWithColon(toSentenceCase($t(detailsRow.label))) }}
                </div>
                <div v-if="hasEntityDetails" class="details__content col-11">
                    <chips-list
                        v-if="detailsRow.type === entityDisplayTypes.chipsList"
                        :items="entity[detailsRow.field]"
                        :field="detailsRow.chipField"
                        :max-num-chips-to-display="detailsRow.maxNumChips"
                    />
                    <div v-else-if="detailsRow.type === entityDisplayTypes.startAndEndDates">
                        {{ weekNumberClient(startDateWeek) }} -
                        {{ weekNumberClient(endDateWeek) }} |
                        {{ dateShorthand(entity.startDate) }} -
                        {{ dateShorthand(entity.endDate) }}
                    </div>
                    <div v-else>
                        {{ entity[detailsRow.field] }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { isEmpty, get } from 'lodash';
import entityDisplayTypes from '@enums/entity-display-types';

const props = defineProps({
    entity: {
        type: Object,
        required: true,
    },
    detailsConfig: {
        type: Array,
        required: true,
    },
    customFirstRow: {
        type: Boolean,
        required: false,
        default: false,
    },
    showDetails: {
        type: Boolean,
        required: false,
        default: true,
    },
});

const store = useStore();

const hasEntityDetails = computed(() => !isEmpty(props.entity));
const endDateWeek = computed(() =>
    get(store.getters['weeks/getWeekByDate'](props.entity.endDate), 'weekOfYear')
);
const startDateWeek = computed(() =>
    get(store.getters['weeks/getWeekByDate'](props.entity.startDate), 'weekOfYear')
);
</script>

<style lang="scss" scoped>
.wrapper {
    display: grid;
    grid-template-columns: minmax(15rem, 30rem) minmax(15rem, 1fr);
}
.details {
    width: 75%;
    display: flex;
    align-items: baseline;
    margin-left: 2rem;
    margin-top: 1rem;

    &__label {
        font-size: 1.2rem;
        text-align: right;
        padding: 0;
    }

    &__content {
        margin-left: 2rem;
        font-size: 1.2rem;
        padding: 0;
    }
}
.spacer {
    margin-left: 9rem;
}
</style>
